<template>
  <div>
    <div class="search-content">
      <el-col :span="24" class="toobar">
        <el-col :span="3" v-if="auditstatus==2">
          <CommonTree ref="treeDserial" :treeHeight="180" :searchText="serveuname" :inputSize="'mini'" @check="changeServer" placeholder="请选择业务员"
                      style="width: 150px;"
                      :isShowCheckBox="false"></CommonTree>
        </el-col>
        <el-col :span="12">
          <el-input style="width:200px;" size="mini"
                    placeholder="请输入名称查询"
                    prefix-icon="el-icon-search"
                    v-model="searchdata">
          </el-input>
          <el-input style="width:120px;" size="mini"
                    placeholder="手机号"
                    prefix-icon="el-icon-search"
                    v-model="linkmantel">
          </el-input>
          <el-input style="width:120px;" size="mini"
                    placeholder="注册人姓名"
                    prefix-icon="el-icon-search"
                    v-model="linkman">
          </el-input>
          <el-select v-model="servedserial" placeholder="请选择" @change="change1" v-show="auditstatus==2&&idd.length>1" size="mini"
                     style="width: 150px">
            <el-option
              v-for="item in idd"
              :key="item.serialnum"
              :label="item.dname"
              :value="item.serialnum">
            </el-option>
          </el-select>
          <el-select v-model="settingmenthod" placeholder="结算方式" style="width:90px" size="mini">
            <el-option label="" value="">结算方式</el-option>
            <el-option label="现金" value="100">现金</el-option>
            <el-option label="月结" value="200">月结</el-option>
            <el-option label="现金+月结" value="100,200">现金+月结</el-option>
          </el-select>
        </el-col>
        <ExternaldeptEdit ref="DataContactEditOther" @AfterSave="bindGrid"></ExternaldeptEdit>
        <ExternaldeptAdd ref="ExternaldeptAdd1"></ExternaldeptAdd>
        <CustomerService ref="customerService"></CustomerService>
        <ReasonDialog ref="ReasonEdit" @bindGrid="bindGrid"></ReasonDialog>
        <!--<el-select v-model="auditstatus" placeholder="请选择" style="width:100px" v-if="status3">-->
        <!--<el-option-->
        <!--v-for="item in auditArr"-->
        <!--:key="item.value"-->
        <!--:label="item.label"-->
        <!--:value="item.value">-->
        <!--</el-option>-->
        <!--</el-select>-->
        <el-button type="primary" icon="el-icon-search" @click="bindGrid" size="mini">搜索</el-button>
        <el-button type="warning" v-if="status2" icon="el-icon-edit" size="mini" @click="addStore">增加门店</el-button>

        <!--<el-button type="warning" @click="excelPort" v-if="auditstatus==2">导出</el-button>-->
        <component v-bind:is="which_to_show" ref="DataContactEdit" @AfterSave="AfterSave"></component>
      </el-col>
    </div>
    <el-table
      :data="tableData"
      :height="thistableHeight()"
      size="mini"
      stripe
      border
      v-show="status1"
      style="width: 100%;">
      <el-table-column
        width="60"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
        </template>
      </el-table-column>
      <el-table-column
        prop="adddate"
        label="提交日期"
        header-align="center"
        align="left"
        width="150">
      </el-table-column>
      <!--<el-table-column-->
        <!--prop="title"-->
        <!--label="标题"-->
        <!--align="center" header-align="center">-->
      <!--</el-table-column>-->
      <el-table-column
        label="录入方式"
        header-align="center"
        align="left">
        <template slot-scope="scope">
        {{(scope.row.uguid==''||scope.row.uguid=='客户注册')?'客户在线注册':'业务员登记'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="uname"
        label="提交人"
        header-align="center"
        align="left">
      </el-table-column>
      <el-table-column
        prop="dname"
        label="门店名称"
        align="center" header-align="center">
      </el-table-column>
      <el-table-column
        prop="audituname"
        label="审核人"
        header-align="center"
        align="left" width="150">
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row,$event)">
            <span v-if="CanEdit">审核</span>
            <span v-if="!CanEdit">查看</span>
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)" v-if="CanEdit">驳回
          </el-button>
          <el-button
            size="mini"
            @click="handleDetail(scope.$index, scope.row,$event)" v-if="!CanEdit">订单
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-table
      :data="tableData"
      :height="thistableHeight()"
      size="mini"
      stripe
      border
      v-show="status2"
      style="width: 100%;">
      <el-table-column
        width="60"
        label="序号" fixed
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
        </template>
      </el-table-column>
      <el-table-column
        prop="customerserial" :show-overflow-tooltip="true"
        label="编码"
        align="left" fixed
        header-align="center"
        width="60">
      </el-table-column>
      <el-table-column fixed
        prop="deptname" :show-overflow-tooltip="true"
        label="名称"
        align="left"  width="200px"
        header-align="center">
      </el-table-column>
      <el-table-column
        prop="serveuname" width="80" :show-overflow-tooltip="true"
        label="销售人员"
        align="left"
        header-align="center">
      </el-table-column>
      <el-table-column label="结算方式" align="left" with="100" header-align="center" prop="settingmenthod" width="100">
        <template slot-scope="scope">
          {{getSetname(scope.row.settingmenthod)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="province"
        label="区域"
        align="left" width="160" :show-overflow-tooltip="true"
        header-align="center">
      </el-table-column>
      <el-table-column label="联系人" width="140" align="left" header-align="center" prop="linkman" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="servedname"
        label="服务中心" width="120" :show-overflow-tooltip="true"
        align="left"
        header-align="center">
      </el-table-column>
      <el-table-column
        prop="ticket"
        label="标签" width="120" :show-overflow-tooltip="true"
        align="left"
        header-align="center">
        <template slot-scope="scope">
          {{scope.row.ticket?scope.row.ticket.split('$')[0]:''}}
        </template>
      </el-table-column>
      <el-table-column
        prop="ticket"
        label="打印标签" width="120" :show-overflow-tooltip="true"
        align="left"
        header-align="center">
        <template slot-scope="scope">
          {{scope.row.ticket&&scope.row.ticket.indexOf('$')>-1?scope.row.ticket.split('$')[1]:''}}
        </template>
      </el-table-column>
      <el-table-column
        prop="descri" :show-overflow-tooltip="true"
        label="近半年订单"
        align="left" width="250px"
        header-align="center">
      </el-table-column>
      <!--<el-table-column-->
        <!--prop="regdate"-->
        <!--label="提交日期"-->
        <!--header-align="center"-->
        <!--align="left"-->
        <!--width="145">-->
      <!--</el-table-column>-->
      <el-table-column
        prop="adddate"
        label="审核日期"
        header-align="center"
        align="left"
        width="145">
      </el-table-column>
      <el-table-column
        prop="adduname"
        label="审核人" :show-overflow-tooltip="true"
        header-align="center"
        align="left"
        width="70">
      </el-table-column>
      <el-table-column
        prop="adduname"
        label="录入"
        header-align="center"
        align="left"
        width="80">
        <template slot-scope="scope">
        {{scope.row.casestatus==1?'客户':(scope.row.casestatus==2?'业务':scope.row.uname)}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="125" v-if="showButtonColum">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="distributorHandleEdit(scope.$index, scope.row,$event)">查看
          </el-button>
          <el-button
            size="mini"
            @click="uptCustomerService(scope.$index, scope.row,$event)" v-if="false">修改客服
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="foot">
      <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
    </div>
  </div>
</template>
<script>
  import ExternaldeptEdit from '../../set/externaldept/ExternaldeptEdit';
  import ExternaldeptAdd from './ExternaldeptAdd';
  import CustomerService from './CustomerService';
  import ReasonDialog from './ReasonDialog';
  import {getListData, removeData, pass, registerApi} from '@/api/workflow/waitaudit';
  import {getListData as deptList} from '@/api/set/externaldept';
  import {independentDept} from '@/api/set/dept';

  export default {
    name: 'waitauditlist',
    data() {
      return {
        dialogVisible: false,
        linkman: '',
        linkmantel: '',
        which_to_show: "",
        showButtonColum: true,
        CanEdit: true,
        EditData: [],
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        searchdata: "",
        loading: true,
        pagination: {
          currentPage: 1,
          pageSize: 20,
          total: 0
        },
        tableData: [],
        status1: true,
        status2: false,
        status3: true,
        status4: true,
        idd: [],
        servedserial: '',
        settingmenthod:'',
        servedname: '',
        serveuguid: '',//业务员ID
        serveuname: '',//业务员名称
      }
    },
    props: {
      auditstatus: {
        default: ""
      }
    },
    methods: {
      addStore() {
        this.$refs.ExternaldeptAdd1.show();
      },
      getSetname(setname) {
        if (!setname) return '';
        setname = setname.replace('100', '现金').replace('200', '月结');
        if (setname.startsWith(',')) {
          setname = setname.substr(1);
        }
        if (setname == '现金,月结') {
          setname = '月结,现金'
        }
        return setname;
      },
      //选择业务员后
      changeServer(guids, names, arr) {
        this.serveuguid = guids;
        this.serveuname = names;
      },
      thistableHeight() {
        return this.tableHeight(116);
      },
      change1(val) {
        this.servedserial = val
        for (let i = 0; i < this.idd.length; i++) {
          if (val == this.idd[i].serialnum) this.servedname = this.idd[i].dname
        }
      },
      uptCustomerService(index, row, event) {
        this.$refs.customerService.show();
        this.$refs.customerService.initData(row.unitguid);
      },
      distributorHandleEdit(index, row, event) {
        this.$refs.DataContactEditOther.show();
        this.$refs.DataContactEditOther.initData(row.unitguid, false);
      },
      //跳转编辑页面
      handleEdit(index, row, event) {
        this.EditData = row;

        if (this.which_to_show != row.components) {
          this.which_to_show = row.components;
          var t = setTimeout(function () {
            event.target.click();
          }, 300);
        } else {
          this.$refs.DataContactEdit.ShowAudit(JSON.parse(this.EditData.yecontent), this.CanEdit, row.unitguid);
        }
      },
      handleDelete(index, row) {
        this.$refs.ReasonEdit.show(row);
      },
      AfterSave(formdate, yeUnitGuid) {//保存后执行方法
        pass({
          unitguid: this.EditData.unitguid,
          uguid:this.EditData.uguid,
          yecontent: JSON.stringify(formdate),
          yeunitguid: yeUnitGuid
        }).then(response => {
          this.bindGrid();
        });
      },
      //绑定分页参数
      bindGrid() {
        var indtserial = this.userInfoModel.independentserial;
        if (indtserial == '') {
          this.status4 = false;
          if (this.auditstatus == 1) {
            this.getWaitaudit();
          } else {
            this.getExternaldept();
          }
        } else {
          this.getExternaldept();
        }
      },
      getWaitaudit() {

        this.status1 = true;
        this.status2 = false;
        this.status3 = true;

        getListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          searchname: this.searchdata,
          showaudit: this.auditstatus,

        }).then(response => {
          this.CanEdit = this.auditstatus == '1';
          this.tableData = response.data.obj.rows
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          console.log(error)
        })
      },

      getExternaldept() {
        this.status1 = false;
        this.status2 = true;
        deptList({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          search: this.searchdata,
          unitgroup: '1',
          linkman: this.linkman,
          linkmantel: this.linkmantel,
          servedserial: this.servedserial,
          serveuguid: this.serveuguid,
          settingmenthod:this.settingmenthod,
          needright:'true',
          orderbydate:'true',
          showorderdate:"1"
        }).then(response => {
          this.tableData = response.data.obj.rows

          for (var i = 0; i < this.tableData.length; i++) {
            this.tableData[i].province = this.tableData[i].province + this.tableData[i].city + this.tableData[i].county
            this.tableData[i].linkman = this.tableData[i].linkman + this.tableData[i].linkmantel
          }
          this.pagination.total = response.data.obj.total
          // getParameterDetail({paraname: "客户价格等级"}).then(response => {
          //   this.parameterData = JSON.parse(response.data.obj.paracontent)
          // })
        }).catch((error) => {
          console.log(error)
        });
      },
      // fmtDate(obj) {
      //   var date = new Date(obj);
      //   var y = 1900 + date.getYear();
      //   var m = "0" + (date.getMonth() + 1);
      //   var d = "0" + date.getDate();
      //
      //   return y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length);
      // },
      // excelPort() {
      //   deptList({
      //     search: this.searchdata,
      //     unitgroup: '1',
      //     linkman: this.linkman,
      //     linkmantel: this.linkmantel,
      //   }).then(response => {
      //     let data = response.data.obj.rows
      //     for (var i = 0; i < data.length; i++) {
      //       data[i].province = data[i].province + data[i].city + data[i].county
      //       if (data[i].pricelevel == '10') data[i].pricelevel = '加工服务中心价'
      //       if (data[i].pricelevel == '20') data[i].pricelevel = '批发价'
      //       if (data[i].pricelevel == '30') data[i].pricelevel = '网络客户'
      //       if (data[i].pricelevel == '40') data[i].pricelevel = '门店'
      //       if (data[i].pricelevel == '50') data[i].pricelevel = '零售价'
      //     }
      //     let header1 = ["编码", "门店名称", "注册时间", "审核通过时间", "联系人", "联系电话", "门店所在区域", "价格等级", "服务商"]
      //     let column1 = ["customerserial", "deptname", "adddate", "adddate", "linkman", "linkmantel", "province", "pricelevel", "servedname"]
      //     var name = new Date();
      //     name = this.fmtDate(name);
      //     this.$exportExcel(header1, column1, data, name)
      //   }).catch((error) => {
      //     console.log(error)
      //   })
      //
      // },
    },

    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.servedserial = this.userInfoModel.independentserial;//只显示本单位的

      this.servedname = this.userInfoModel.tenantname
      independentDept().then(response => {
        this.idd = response.data.obj
        if (this.userInfoModel.independentserial == "") {
          this.idd.unshift({serialnum: "all", dname: "全部"})
          this.servedserial = 'all';
        }
        this.bindGrid();
      })
    },
    components: {
      ExternaldeptEdit,
      CustomerService,
      ReasonDialog,
      ExternaldeptAdd
    }
  }
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/workflow/waitaudit/waitauditList.vue